module.exports = "/images/role-designer-icon.svg?680de79a3595151d5e769330bf6d86bd";